import React, { useEffect, useState, useRef, useMemo} from "react";
import './wbs2iframe-row.css';
import { showToast } from './toastUtils';
import FullscreenLoader from './FullscreenLoader';
import { queuedApiFetch, apiFetch } from './api';
import Swal from 'sweetalert2';
import withReactContent from 'sweetalert2-react-content';
const MySwal = withReactContent(Swal);

function Wbs2iframerow({propwidth}) {


  const widthDescription = document.getElementById('description-wbs');
  const widthContract = document.getElementById('contract-wbs');
  const widthConversion = widthContract?.offsetWidth + widthDescription?.offsetWidth;

  const [wbsColumns, setWbsColumns] = useState([]);
  const [rows, setRows] = useState([]);
  const [newGroup, setNewGroup] = useState("");
  const [groupOptions, setGroupOptions] = useState([]);
  // const [selectedGroup, setSelectedGroup] = useState("");
  const [selectedGroup, setSelectedGroup] = useState([]);
  const [itemDescription, setItemDescription] = useState("");
  const [addedItems, setAddedItems] = useState([]);
  const [costValues, setCostValues] = useState([]);
  const getUserDetails = localStorage.getItem('userDetails');
  const userDetails = getUserDetails ? JSON.parse(getUserDetails) : '';
  const userId = userDetails ? userDetails.id : '';
  const getUserAccess = userDetails ? userDetails.access_level : '';
  const getProjectDetails = localStorage.getItem('projectDetails');
  const selectedProjectDetail = JSON.parse(getProjectDetails);
  const projectid = selectedProjectDetail.projectNumber;
  const [WBSTableLoading, setWBSTableLoading] = useState(true);
  const [loading, setLoading] = useState(true);
  const [WBSEditTableLoading, setWBSEditTableLoading] = useState(true);
  const [addGroupLoading, setAddGroupLoading] = useState(false);
  const [addItemLoading, setAddItemLoading] = useState(false);
  const [finalSubmitLoading, setFinalSubmitLoading] = useState(false);
  const getUserEmail = localStorage.getItem('userEmail');
  const [userPermission, setUserPermission] = useState();
  const [userRoleManual, setUserRolesManual] = useState();
  const [userCompany, setUserCompany] = useState();
  const getUserCompanyDetails = userCompany;
  const [focusedInput, setFocusedInput] = useState(null); // e.g. 'group-0-desc-1-col-2'
  const originalListRef = useRef([]);
  const [proj_access_level, setProjAccessLevel] = useState(false);
  const [save_sts, setSaveSts] = useState(false);

  const fetchData = async () => {
    try {
      await fetchUserCompany();
      await fetchUserRole();
    } catch (error) {
      console.error("Error fetching data:", error);
    }
  };

  // useEffect(() => {
  //         fetchData();
  // }, []);

  const fetchUserRole = async () => {
    if (!userId || !projectid) {
      return;
    }
    const requestOptions = {
      method: 'GET',
      //headers: new Headers({ 'ngrok-skip-browser-warning': '69420' })
    };
    try {
      const response = await queuedApiFetch(`/project/get_project_role?userid=${userId}&projectid=${projectid}`, requestOptions);
      const data = await response;

      if (data.apistatus.Status_Code === 200 && data.apistatus.Status_Description.toLowerCase() === 'success') {
        // console.log(data.data);
        setUserRolesManual(data.data);
        setProjAccessLevel(data.access_level);
        //setUserRolesManual('Project Manager (PM)');
      }
    } catch (error) {
      console.error('Error fetching data:', error);
    } finally {
      setLoading(false); // End loading
    }
  }

  const fetchUserCompany = async () => {
    const requestOptions = {
      method: 'GET',
      //headers: new Headers({ 'ngrok-skip-browser-warning': '69420' })
    };
    try {
      const response = await queuedApiFetch(`/user/getuserprofile?emailid=${getUserEmail}`, requestOptions);
      const data = await response;

      if (data.apistatus.Status_Code === 200 && data.apistatus.Status_Description.toLowerCase() === 'success') {
        setUserCompany(data.data.company_name);
        setUserPermission(data.data.access_level);
      }
    } catch (error) {
      console.error('Error fetching data:', error);
    } finally {
      // setLoading(false); // End loading
    }
  }

  const formatCurrency = (amount) => {
    return new Intl.NumberFormat('en-US', {
      style: 'currency',
      currency: 'USD',
      currencyDisplay: 'symbol' // This will display the currency code (USD) instead of the symbol.
    }).format(amount);
  };

  const fetchWBSData = async () => {
    setWBSTableLoading(true);
    const requestOptions = {
      method: "GET",
      //headers: new Headers({ 'ngrok-skip-browser-warning': '69420' }),
    };

    try {
      const response = await queuedApiFetch(`/funding/getwbs?projectid=${projectid}`,
        requestOptions
      );
      const data = await response;

      if (data.apistatus.Status_Code === 200) {
        const wbsCodes = [...new Set(data.data.map((item) => item.WBS_ID))];
        setWbsColumns(wbsCodes);

        const formattedRows = [
          {
            description: "BUC No.",
            data: data.data
              .filter((item) => item.DESCRIPTION === "BUC No.")
              .map((item) => ({ id: item.ID, value: item.WBS_VALUE })),
            total: data.data
              .filter((item) => item.DESCRIPTION === "BUC No.")
              .reduce((acc, item) => acc + item.WBS_VALUE, 0),
          },
          {
            description: "Fund Code.",
            data: data.data
              .filter((item) => item.DESCRIPTION === "Fund Code.")
              .map((item) => ({ id: item.ID, value: item.WBS_VALUE })),
            total: data.data
              .filter((item) => item.DESCRIPTION === "Fund Code.")
              .reduce((acc, item) => acc + item.WBS_VALUE, 0),
          },
          {
            description: "Approved Budget",
            data: data.data
              .filter((item) => item.DESCRIPTION === "Approved Budget")
              .map((item) => ({ id: item.ID, value: parseFloat(item.WBS_VALUE) })),
            total: data.data
              .filter((item) => item.DESCRIPTION === "Approved Budget")
              .reduce((acc, item) => parseFloat(acc) + parseFloat(item.WBS_VALUE), 0),
          },
        ];

        setRows(formattedRows);
      }
    } catch (error) {
      console.error("Error fetching data:", error);
    } finally {
      setWBSTableLoading(false);
    }
  };


  const handleAddGroup = async () => {
    if (!addGroupLoading) {
      if (newGroup == '') {
        showToast.error('Please enter a group description');
        return;
      }
      setAddGroupLoading(true);
      const sendData = { Project_id: projectid, P_grp_desc: newGroup };
      const requestOptions = {
        method: 'POST',
        // headers: {
        //   'Content-Type': 'application/json',
        //   'ngrok-skip-browser-warning': '69420'
        // },
        body: JSON.stringify(sendData),
      };

      try {
        const response = await queuedApiFetch('/funding/insertgroupmaster', requestOptions);
        const result = await response;
        if (result.exist === 1) {
          showToast.error(result.apistatus?.Status_Description || 'Group already exists!');
        } else {
          // Group successfully added
          showToast.success(result.message || 'Group added successfully');
          getGroupList();       // Refresh group list
        }
        setNewGroup(""); // Clear the new group input
      } catch (error) {
        console.error('Error saving data:', error);
      } finally {
        setAddGroupLoading(false); // Reset loading state
      }
    }
  };

  // const handleAddNewItem = async () => {
  //   if (!addItemLoading) {
  //     if (selectedGroup.length === 0) {
  //       showToast.error('Please Select Group');
  //       return;
  //     }
  //     if (itemDescription === ''||selectedGroup.length === 0) {
  //       showToast.error('Please enter an item description');
  //       return;
  //     }
  //     setAddItemLoading(true);

  //     // Ensure selected group and item description are provided
  //     if (selectedGroup && selectedGroup.length > 0 && itemDescription) {
  //       const sendData = {
  //         Project_id: projectid,
  //         P_grp_id: selectedGroup[0].P_grp_id,
  //         P_item_desc: itemDescription
  //       };

  //       const requestOptions = {
  //         method: 'POST',
  //         headers: {
  //           'Content-Type': 'application/json',
  //           'ngrok-skip-browser-warning': '69420'
  //         },
  //         body: JSON.stringify(sendData)
  //       };

  //       try {
  //         // Fetch API call to add the new item
  //         const response = await queuedApiFetch('/funding/insertitemmaster', requestOptions);
  //         const result = await response;

  //         showToast.success(result.message || 'Data saved successfully');

  //         const newItemId = result.data?.P_item_id;

  //         setAddedItems((prevItems) => {
  //           const existingGroupIndex = prevItems.findIndex(
  //             (item) => item.group === selectedGroup[0].P_grp_desc
  //           );

  //           if (existingGroupIndex !== -1) {
  //             const updatedGroup = {
  //               ...prevItems[existingGroupIndex],
  //               descriptions: [...prevItems[existingGroupIndex].descriptions]
  //             };

  //             const descriptionExists = updatedGroup.descriptions.some(
  //               (desc) => desc.description === itemDescription
  //             );

  //             if (!descriptionExists) {
  //               updatedGroup.descriptions.push({
  //                 description: itemDescription,
  //                 itemId: newItemId,
  //                 wbsValues: { WBS1: 0, WBS2: 0 }
  //               });
  //             }

  //             const updatedItems = [
  //               ...prevItems.slice(0, existingGroupIndex),
  //               updatedGroup,
  //               ...prevItems.slice(existingGroupIndex + 1)
  //             ];

  //             return updatedItems;
  //           } else {
  //             return [
  //               ...prevItems,
  //               {
  //                 group: selectedGroup[0].P_grp_desc,
  //                 groupId: selectedGroup[0].P_grp_id,
  //                 descriptions: [
  //                   {
  //                     description: itemDescription,
  //                     itemId: newItemId,
  //                     wbsValues: { WBS1: 0, WBS2: 0 }
  //                   }
  //                 ]
  //               }
  //             ];
  //           }
  //         });

  //         // Clear input fields after successful addition
  //         setItemDescription("");
  //         setSelectedGroup("");
  //       } catch (error) {
  //         console.error("Error saving data:", error);
  //       } finally {
  //         setAddItemLoading(false); // Reset loading state
  //       }
  //     }
  //   }
  // };

  const handleAddNewItem = async () => {
    if (!addItemLoading) {
      if (selectedGroup.length === 0) {
        showToast.error('Please Select Group');
        return;
      }

      if (itemDescription === '') {
        showToast.error('Please enter an item description');
        return;
      }

      setAddItemLoading(true);

      const sendData = {
        Project_id: projectid,
        P_grp_id: selectedGroup[0].P_grp_id,
        P_item_desc: itemDescription
      };

      const requestOptions = {
        method: 'POST',
        // headers: {
        //   'Content-Type': 'application/json',
        //   'ngrok-skip-browser-warning': '69420'
        // },
        body: JSON.stringify(sendData)
      };

      try {
        const response = await queuedApiFetch(`/funding/insertitemmaster`,
          requestOptions
        );
        const result = await response;

        if (result.exist === 1) {
          showToast.error(result.apistatus?.Status_Description || 'Item already exists!');
          return;
        } else {
          showToast.success(result.message || 'Data saved successfully');
        }
        const newItemId = result.data?.P_item_id;

        setAddedItems((prevItems) => {
          const existingGroupIndex = prevItems.findIndex(
            (item) => item.group === selectedGroup[0].P_grp_desc
          );

          let updatedItems;

          if (existingGroupIndex !== -1) {
            const updatedGroup = {
              ...prevItems[existingGroupIndex],
              descriptions: [...prevItems[existingGroupIndex].descriptions]
            };

            const descriptionExists = updatedGroup.descriptions.some(
              (desc) => desc.description === itemDescription
            );

            if (!descriptionExists) {
              updatedGroup.descriptions.push({
                description: itemDescription,
                itemId: newItemId,
                wbsValues: wbsColumns.reduce((acc, wbsId) => ({ ...acc, [wbsId]: '0' }), {}), // Initialize with '0' for all WBS columns
              });
            }

            updatedItems = [
              ...prevItems.slice(0, existingGroupIndex),
              updatedGroup,
              ...prevItems.slice(existingGroupIndex + 1)
            ];
          } else {
            updatedItems = [
              ...prevItems,
              {
                group: selectedGroup[0].P_grp_desc,
                groupId: selectedGroup[0].P_grp_id,
                descriptions: [
                  {
                    description: itemDescription,
                    itemId: newItemId,
                    wbsValues: wbsColumns.reduce((acc, wbsId) => ({ ...acc, [wbsId]: '0' }), {}), // Initialize with '0' for all WBS columns
                  }
                ]
              }
            ];
          }

          const startPriority = [1, 2, 3];
          const endPriority = [4, 5];

          updatedItems.sort((a, b) => {
            const aId = a.groupId;
            const bId = b.groupId;

            const aStart = startPriority.indexOf(aId);
            const bStart = startPriority.indexOf(bId);

            const aEnd = endPriority.indexOf(aId);
            const bEnd = endPriority.indexOf(bId);

            if (aStart !== -1 && bStart !== -1) return aStart - bStart;
            if (aStart !== -1) return -1;
            if (bStart !== -1) return 1;

            if (aEnd !== -1 && bEnd !== -1) return aEnd - bEnd;
            if (aEnd !== -1) return 1;
            if (bEnd !== -1) return -1;

            return aId - bId; // default order for middle groups
          });

          return updatedItems;
        });

        // Clear input fields
        setItemDescription("");
        setSelectedGroup("");
      } catch (error) {
        console.error("Error saving data:", error);
        showToast.error('Failed to save item. Please try again.');
      } finally {
        setAddItemLoading(false);
      }
    }
  };


  // const formatAsCurrency = (value) => {
  //   let numericValue = String(value).replace(/[^0-9.]/g, '');
  //   if (!numericValue || isNaN(numericValue)) return '';
  //   const number = parseFloat(numericValue);
  //   let formattedValue = number.toLocaleString('en-US');
  //   return formattedValue;
  // };

  
  const formatAsCurrency = (value) => {
    const num = parseFloat(value);
    //if (isNaN(num) || num === 0) return '';
    if (isNaN(num)) return '';

    return num.toLocaleString('en-US', {
      minimumFractionDigits: 2,
      maximumFractionDigits: 2,
    });
  };


  // const isValidNumber = (value) => {
  //   return !isNaN(value) && value !== '';
  // };

  const isValidNumber = (value) => {
    return /^-?\d*\.?\d*$/.test(value);
  };

  const isEmptyValue = (value) => {
    return (
      value === '0' ||
      value === 0 ||
      value === '' ||
      value === null ||
      value === undefined
    );
  };


  // const handleCostInputChange = (groupIndex, descIndex, columnIndex, newValue) => {
  //   const updatedAddedItems = [...addedItems];
  //   updatedAddedItems[groupIndex].descriptions[descIndex].wbsValues[wbsColumns[columnIndex]] = newValue;

  //   const totalProjectCostPerColumn = wbsColumns.map((_, colIndex) => {
  //     const allGroupTotalValue = updatedAddedItems.reduce((groupAcc, group) => {
  //       return groupAcc + group.descriptions.reduce((descAcc, descriptionObj) => {
  //         return descAcc + (parseFloat(descriptionObj.wbsValues?.[wbsColumns[colIndex]]) || 0);
  //       }, 0);
  //     }, 0);
  //     const ninePercentValue = allGroupTotalValue * 0.09;
  //     return allGroupTotalValue + ninePercentValue;
  //   });

  //   const approvedBudgets = rows.find(row => row.description === "Approved Budget");

  //   if (approvedBudgets) {
  //     const approvedBudgetValues = approvedBudgets.data.map((item) => parseFloat(item.value));
  //     const updatedColumn = wbsColumns[columnIndex];
  //     const approvedBudget = approvedBudgetValues[columnIndex];

  //     if (totalProjectCostPerColumn[columnIndex] > approvedBudget) {
  //       showToast.error(`Total Project Cost for ${updatedColumn} exceeds the approved budget!`);
  //       updatedAddedItems[groupIndex].descriptions[descIndex].wbsValues[wbsColumns[columnIndex]] = ' ';
  //       setAddedItems(updatedAddedItems);
  //       return;
  //     }
  //   }

  //   setAddedItems(updatedAddedItems);
  // };

  const handleCostInputChange = (groupIndex, descIndex, columnIndex, newValue) => {
    const updatedAddedItems = [...addedItems];

    // --- START MODIFICATION: Normalize value on change for consistent state tracking ---
    let valueToStore = newValue;
    //if (newValue === '' || newValue === null || String(newValue).replace(/[^0-9.]/g, '') === '') {

    // if (newValue === '' || newValue === null || String(newValue).replace(/[^0-9.-]/g, '') === '') {
    //     valueToStore = '0'; // Store '0' if input is empty or cleared
    //     //valueToStore = ''; // Store '0' if input is empty or cleared
    // } else {
    //     // Store the raw value as a string (may still have commas)
    //     valueToStore = String(newValue);
    // }

    if (newValue === null) {
      valueToStore = '0';
    } else {
      valueToStore = String(newValue);
    }


    // Save the raw value (or '0') as entered by the user
    // updatedAddedItems[groupIndex].descriptions[descIndex].wbsValues[wbsColumns[columnIndex]] = valueToStore;
    updatedAddedItems[groupIndex].descriptions[descIndex].wbsValues[wbsColumns[columnIndex]] = valueToStore;
    // --- END MODIFICATION ---

    // Recalculate total project cost after the update
    const totalProjectCostPerColumn = wbsColumns.map((_, colIndex) => {
      const allGroupTotalValue = updatedAddedItems.reduce((groupAcc, group) => {
        return groupAcc + group.descriptions.reduce((descAcc, descriptionObj) => {
          const raw = descriptionObj.wbsValues?.[wbsColumns[colIndex]];
          const cleaned = parseFloat(String(raw).replace(/,/g, '')); // Remove commas
          return descAcc + (isNaN(cleaned) ? 0 : cleaned);
        }, 0);
      }, 0);

      const ninePercentValue = allGroupTotalValue * 0.09;
      return allGroupTotalValue + ninePercentValue;
    });

    const approvedBudgets = rows.find(row => row.description === "Approved Budget");

    // Check if the new total exceeds the approved budget
    if (approvedBudgets) {
      const approvedBudgetValues = approvedBudgets.data.map((item) => parseFloat(item.value));
      const updatedColumn = wbsColumns[columnIndex];
      const approvedBudget = approvedBudgetValues[columnIndex];

      if (totalProjectCostPerColumn[columnIndex] > approvedBudget) {
        showToast.error(`Total Project Cost for ${updatedColumn} exceeds the approved budget!`);

        // Reset to '0'
        updatedAddedItems[groupIndex].descriptions[descIndex].wbsValues[wbsColumns[columnIndex]] = '0';
        //updatedAddedItems[groupIndex].descriptions[descIndex].wbsValues[wbsColumns[columnIndex]] = '';
        setAddedItems(updatedAddedItems);
        return;
      }
    }

    setAddedItems(updatedAddedItems);
  };

  // const isValidCurrencyLength = (value, maxDigits = 14) => {
  //   // Remove commas
  //   const cleanedValue = value.replace(/,/g, '');

  //   // Ignore decimal part
  //   const integerPart = cleanedValue.split('.')[0];

  //   // Count only numeric digits
  //   const numericOnly = integerPart.replace(/\D/g, '');

  //   return numericOnly.length <= maxDigits;
  // };

  const isValidCurrencyLength = (value, maxLength) => {
    
    //const digitCount = value.replace(/[$,\s]/g, '').length; // Except $ and ,
    //const digitCount = value.replace(/[^0-9]/g, '').length;
    const digitCount = value.replace(/[^0-9.-]/g, '').length;
    return digitCount <= maxLength;
  };


  // --- START MODIFICATION: Enhanced cleanNestedRawInput for reliable comparison ---
  /**
   * Cleans addedItems data for comparison by normalizing WBS values to fixed-point strings.
   */
  function cleanNestedRawInput(dataList) {
    // Ensure dataList is treated as an array even if it's the Ref object's current value (which might be null/undefined initially)
    const list = Array.isArray(dataList) ? dataList : [];

    return list.map(group => ({
      ...group,
      descriptions: group.descriptions.map(desc => ({
        ...desc,
        wbsValues: Object.entries(desc.wbsValues).reduce((acc, [wbsId, value]) => {
          // Clean value: remove commas and parse as float
          const cleaned = parseFloat(String(value).replace(/,/g, '')) || 0;
          // Normalize to a string with two decimal places for consistent comparison
          acc[wbsId] = cleaned.toFixed(2);
          return acc;
        }, {})
      }))
    }));
  }
  // --- END MODIFICATION ---

  // Compare ref (original) with current editable data
  const isModified = useMemo(() => {

    // Clean both the current state and the reference state for comparison
    const original = JSON.stringify(cleanNestedRawInput(originalListRef.current));
    const current = JSON.stringify(cleanNestedRawInput(addedItems));

    // Check if the stringified, cleaned versions are different
    var sts = (original !== current)
    //console.log("modified sts",sts,"final submit loading sts",finalSubmitLoading);
    return sts;

  }, [addedItems]);


  const getGroupList = async () => {
    const requestOptions = {
      method: "GET",
      //headers: new Headers({ 'ngrok-skip-browser-warning': '69420' }),
    };

    try {
      const response = await queuedApiFetch(`/funding/getgroupmaster?projectid=${projectid}`,
        requestOptions
      );
      const data = await response;

      if (data.apistatus.Status_Code === 200 && data.apistatus.Status_Description.toLowerCase() === 'success') {
        const filteredOptions = data.data.filter(
          // (item) => item.P_grp_type !== 'D' && item.P_grp_type !== 'DL'
          (item) => item.P_grp_type !== ' '
        );
        setGroupOptions(filteredOptions);
      }
      // console.log("Group List Data:", groupOptions);
    } catch (error) {
      console.error("Error fetching group list data:", error);
    }
  };


  // Handle select change
  const handleSelectChange = (e) => {
    const selectedGroupId = e.target.value;
    const selectedGroupObject = groupOptions.find(
      (group) => group.P_grp_id === parseInt(selectedGroupId)
    );
    setSelectedGroup([selectedGroupObject]); // Store the entire selected group object inside an array
    // console.log('Selected Group Details:', selectedGroupObject);
  };

  useEffect(() => {
    fetchData();
    fetchWBSData();
    getGroupList();
    fetchEditWBSData();
  }, []);

  // **********************************************
  // FIX: Set originalListRef.current after addedItems state is fully populated on load
  // **********************************************
  useEffect(() => {
      // Check if addedItems has been populated from the initial fetch
      if (addedItems.length > 0 && originalListRef.current.length === 0) {
          // Deep clone addedItems to originalListRef.current for initial comparison
          originalListRef.current = JSON.parse(JSON.stringify(addedItems));
          //console.log('Original List Ref set:', originalListRef.current);
      }
  }, [addedItems]);
  // **********************************************
  // END FIX
  // **********************************************


  const finalSubmit = async () => {
    if (!finalSubmitLoading && isModified) { // Check isModified again before submission
      setFinalSubmitLoading(true);
      const projectId = projectid; // Set your project ID

      // Format the data by extracting necessary values from addedItems
      const formattedData = addedItems.flatMap((group) =>
        group.descriptions.flatMap((descriptionObj) => {
          const description = descriptionObj.description; // Extract description
          const wbsValues = descriptionObj.wbsValues; // Extract wbsValues object

          // Map through each WBS ID in the wbsValues and create a new data entry
          return Object.entries(wbsValues).map(([wbsId, value]) => {
            // If the value is a space, replace it with '0'
            let cleanedValue = value;
            if (value === ' ' || value === '' || value === undefined || value === null) {
              cleanedValue = '0';
              //cleanedValue = '';
            } else {
              // Remove commas from the value before sending to API
              cleanedValue = String(value).replace(/,/g, '');
            }
            return {
              id: 0, // Adjust ID logic as needed
              Project_id: projectId,
              P_grp_id: group.groupId, // Use the groupId for P_grp_id
              P_grp_item_id: descriptionObj.itemId, // Use the itemId for P_grp_item_id
              P_grp_wbs_id: wbsId, // Use WBS ID from wbsValues
              //P_grp_wbs_value: cleanedValue === '' ? '0' : cleanedValue // Set the WBS value
              P_grp_wbs_value: cleanedValue, // Set the WBS value
            };
          });
        })
      );

      // Calculate the total project cost per column with the added new values
      const totalProjectCostPerColumn = wbsColumns.map((_, colIndex) => {
        const allGroupTotalValue = addedItems.reduce((groupAcc, group) => {
          return groupAcc + group.descriptions.reduce((descAcc, descriptionObj) => {
            const rawValue = descriptionObj.wbsValues?.[wbsColumns[colIndex]];
            const cleaned = parseFloat(String(rawValue).replace(/,/g, ''));
            return descAcc + (isNaN(cleaned) ? 0 : cleaned);
          }, 0);
        }, 0);
        const ninePercentValue = allGroupTotalValue * 0.09; // 9% of the total value
        return allGroupTotalValue + ninePercentValue; // Add the 9% to the total value
      });

      // Find the row where the description is "Approved Budget"
      const approvedBudgets = rows.find(row => row.description === "Approved Budget");

      if (approvedBudgets) {
        const approvedBudgetValues = approvedBudgets.data.map((item) => parseFloat(item.value));

        // Loop through all the columns and check if the total project cost exceeds the approved budget
        for (let colIndex = 0; colIndex < wbsColumns.length; colIndex++) {
          const approvedBudget = approvedBudgetValues[colIndex];

          if (totalProjectCostPerColumn[colIndex] > approvedBudget) {
            showToast.error(`Total Project Cost for ${wbsColumns[colIndex]} exceeds the approved budget!`);
            setFinalSubmitLoading(false); // Reset the loading state
            return; // Stop further execution if the budget is exceeded
          }
        }
      }

      const requestOptions = {
        method: 'POST',
        // headers: {
        //   'Content-Type': 'application/json',
        //   'ngrok-skip-browser-warning': '69420',
        // },
        body: JSON.stringify(formattedData),
      };

      try {
        setLoading(true);
        // Make the POST request to save the data
        const response = await queuedApiFetch('/funding/insertwbsgroup', requestOptions);
        const result = await response;

        if (result.apistatus.Status_Code === 200 && result.apistatus.Status_Description.toLowerCase() === 'success') {
          // Correct: Deep clone the current state of addedItems after a successful save
          originalListRef.current = JSON.parse(JSON.stringify(addedItems));
          setSaveSts(true);
          showToast.success('Data saved successfully');
        } else {
          showToast.error(result.apistatus.Status_Description || 'Please try again later');
        }
      } catch (error) {
        setLoading(false);
        console.error('Error saving data:', error);
      } finally {
        setFinalSubmitLoading(false); // Reset the loading state
        setLoading(false);
      }
    }
  };



  const fetchEditWBSData = async () => {
    setWBSEditTableLoading(true);
    const requestOptions = {
      method: "GET",
      //headers: new Headers({ 'ngrok-skip-browser-warning': '69420' }),
    };

    try {
      const response = await queuedApiFetch(`/funding/getwbsgroup?projectid=${projectid}`,
        requestOptions
      );
      const data = await response;

      if (data.apistatus.Status_Code === 200 && data.apistatus.Status_Description.toLowerCase() === 'success') {
        const transformedData = transformWBSData(data.data);

        // This setAddedItems will trigger the new useEffect hook to set originalListRef.current
        setAddedItems((prevItems) => {
          // If no previous items, just set the transformed data
          if (prevItems.length === 0) {
            return transformedData.filter(
              (item) =>
                item.descriptions.length > 0 &&
                item.descriptions[0].description !== null &&
                item.descriptions[0].description !== ""
            );
          }

          // Merge logic for subsequent calls (e.g., if groups are added/fetched later)
          const updatedItems = prevItems.map((existingItem) => {
            // Find if the group exists in the new transformed data
            const newItem = transformedData.find(
              (newItem) => newItem.group === existingItem.group
            );

            // If a matching new item is found, compare the wbsValues
            if (newItem) {
              // In this case, we always want the data from the API to overwrite the old one
              // when fetching for edits, so we return the new item's descriptions.
              return {
                ...existingItem,
                descriptions: newItem.descriptions, // Update the descriptions (which include wbsValues)
              };
            }
            return existingItem; // If no match, return the original item
          });

          // Add new items that weren't in the previous list
          const newItems = transformedData.filter(
            (newItem) =>
              !prevItems.some((existingItem) => existingItem.group === newItem.group)
          );

          const combinedItems = [...updatedItems, ...newItems];

          // Remove items where descriptions[0].description is null or empty
          return combinedItems.filter(
            (item) =>
              item.descriptions.length > 0 &&
              item.descriptions[0].description !== null &&
              item.descriptions[0].description !== ""
          );
        });

        // REMOVED: originalListRef.current = JSON.parse(JSON.stringify(addedItems));
        // This was the source of the empty ref because addedItems was the old state here.
      }
    } catch (error) {
      console.error("Error fetching data:", error);
    } finally {
      setWBSEditTableLoading(false);
    }
  };

  // const transformWBSData = (data) => {
  //   const groups = {};

  //   data.forEach((item) => {
  //     const { P_grp_desc, P_grp_item_desc, P_grp_id, P_grp_item_id, P_grp_wbs_id, P_grp_wbs_value } = item;

  //     // If the group does not exist, initialize it with group information
  //     if (!groups[P_grp_id]) {
  //       groups[P_grp_id] = {
  //         group: P_grp_desc,
  //         groupId: P_grp_id, // Include P_grp_id as groupId
  //         descriptions: []
  //       };
  //     }

  //     // Check if the description already exists for the group
  //     const descriptionIndex = groups[P_grp_id].descriptions.findIndex(
  //       (desc) => desc.description === P_grp_item_desc
  //     );

  //     if (descriptionIndex === -1) {
  //       // If the description doesn't exist, add it with the itemId
  //       groups[P_grp_id].descriptions.push({
  //         description: P_grp_item_desc,
  //         itemId: P_grp_item_id, // Include P_grp_item_id as itemId
  //         wbsValues: { [P_grp_wbs_id]: P_grp_wbs_value }
  //       });
  //     } else {
  //       // If the description exists, update the WBS values
  //       groups[P_grp_id].descriptions[descriptionIndex].wbsValues[P_grp_wbs_id] = P_grp_wbs_value;
  //     }
  //   });
  //   // Convert the groups object into an array of group objects with descriptions array
  //   return Object.values(groups);
  // };

  const transformWBSData = (data) => {
    const groups = {};

    data.forEach((item) => {
      const {
        P_grp_desc,
        P_grp_item_desc,
        P_grp_id,
        P_grp_item_id,
        P_grp_wbs_id,
        P_grp_wbs_value
      } = item;

      if (P_grp_id === 1 && P_grp_item_id === 3) return;

      if (!groups[P_grp_id]) {
        groups[P_grp_id] = {
          group: P_grp_desc,
          groupId: P_grp_id,
          descriptions: []
        };
      }

      const descriptionIndex = groups[P_grp_id].descriptions.findIndex(
        (desc) => desc.description === P_grp_item_desc
      );

      // --- START MODIFICATION: Ensure fetched values are stored as strings without commas ---
      // Clean value: ensure it is a string representation of the number
      const cleanedWBSValue = String(P_grp_wbs_value).replace(/,/g, '');
      // --- END MODIFICATION ---

      if (descriptionIndex === -1) {
        groups[P_grp_id].descriptions.push({
          description: P_grp_item_desc,
          itemId: P_grp_item_id,
          wbsValues: { [P_grp_wbs_id]: cleanedWBSValue } // Use cleaned value
        });
      } else {
        groups[P_grp_id].descriptions[descriptionIndex].wbsValues[P_grp_wbs_id] = cleanedWBSValue; // Use cleaned value
      }
    });

    Object.values(groups).forEach(group => {
      group.descriptions.sort((a, b) => a.itemId - b.itemId);
    });

    // Convert to array
    const groupArray = Object.values(groups);

    // Sort according to custom rules
    const startPriority = [1, 2, 3];
    const endPriority = [4, 5];

    groupArray.sort((a, b) => {
      const aId = a.groupId;
      const bId = b.groupId;

      const aStart = startPriority.indexOf(aId);
      const bStart = startPriority.indexOf(bId);

      const aEnd = endPriority.indexOf(aId);
      const bEnd = endPriority.indexOf(bId);

      if (aStart !== -1 && bStart !== -1) return aStart - bStart;
      if (aStart !== -1) return -1;
      if (bStart !== -1) return 1;

      if (aEnd !== -1 && bEnd !== -1) return aEnd - bEnd;
      if (aEnd !== -1) return 1;
      if (bEnd !== -1) return -1;

      return aId - bId;
    });

    return groupArray;
  };

  const submittoAC = async () => {
    const requestOptions = {
      method: 'GET',
      //headers: new Headers({ 'ngrok-skip-browser-warning': '69420' })
    };
    try {
      const response = await queuedApiFetch(`/funding/submit_to_ac?projectid=${projectid}`, requestOptions);
      const data = await response;

      if (data.apistatus.Status_Code === 200 && data.apistatus.Status_Description.toLowerCase() === 'success') {
        if (data.email_sts == true) {
          showToast.success('Submitted to AC successfully..');
        }
      }
    } catch (error) {
      console.error('Error fetching data:', error);
    } finally {

    }
  }


  const handleSubmitAC = async () => {

    // Validation 1: Check if there are unsaved changes
    // --- START MODIFICATION: Prevent submission if no changes ---
    if (!isModified) {
      MySwal.fire("Info", "No changes detected. Please make changes and save before submitting to AC.", "info");
      return;
    }
    // --- END MODIFICATION ---

    // Validation 2: Ensure there is data to submit (existing check)

    // const hasData = addedItems.some(group => group.descriptions.length > 0);

    // if (!hasData) {
    //   MySwal.fire("Info", "Please make changes and save before submitting to AC.", "info");
    //   //showToast.error("Validation Failed: Please enter and save WBS cost data before submitting to AC.");

    //   return;

    // }

    const hasData = addedItems.some(group => group.descriptions.length > 0);

    if (!save_sts) {
      MySwal.fire("Info", "Please save before submitting to AC.", "info");
      //showToast.error("Validation Failed: Please enter and save WBS cost data before submitting to AC.");

      return;

    }



    // If we reach here, the data is saved (isModified is false) and there is data.

    MySwal.fire({
      title: "Are you sure you want to submit?",
      icon: "warning",
      showCancelButton: true,
      confirmButtonText: "Yes, Submit",
      cancelButtonText: "Cancel",
      reverseButtons: true,
    }).then(async (result) => {
      if (result.isConfirmed) {
        const requestOptions = {
          method: 'GET',
          //headers: new Headers({ 'ngrok-skip-browser-warning': '69420' })
        };
        try {
        setLoading(true);
          const response = await queuedApiFetch(`/funding/submit_to_ac?projectid=${projectid}`, requestOptions);
          const data = await response;

          if (data.apistatus.Status_Code === 200 && data.apistatus.Status_Description.toLowerCase() === 'success') {
            if (data.email_sts == true) {
              setSaveSts(false);
              //showToast.success('Submitted to AC successfully..');
              Swal.fire("Submitted!", "Submitted to AC successfully..", "success");
            } else {
              Swal.fire("Info", "No emails found for this project. No Email sent !", "info");
            }
          }
        } catch (error) {
          setLoading(false);
          //console.error('Error fetching data:', error);
          Swal.fire("Error", "Error fetching data:", "error");
        } finally {
          setLoading(false);
        }

      }
      // If Cancel clicked, Swal will close automatically
    });
  }

    // const btn_sts = (
    //   expectedCompany,
    //   projectAdminRoles = []
    // ) => {
    //   var sts = (
    //     //   (
    //     //   (getUserCompanyDetails === 'NUS' && userPermission === 'account_admin') ||
    //     //   (getUserCompanyDetails === 'NUS' && userPermission === 'project_admin' && userRoleManual === '') ||
    //     //   (getUserCompanyDetails === 'NUS' && userPermission === 'project_admin' && userRoleManual === 'Project Manager (PM)')
    //     //   // (userRoleManual === 'Project Manager (PM)' && (userPermission === 'project_admin' || userPermission === 'account_admin'))
    //     // )

    //     (getUserCompanyDetails === expectedCompany && (userPermission === 'account_admin' || userPermission === 'project_admin') && (userRoleManual?.length === 0 || projectAdminRoles.some(item => userRoleManual?.includes?.(item))))

    //   );
    //   //console.log("button sts", sts)
    //   return sts;
    // };

    const btn_sts = (
      expectedCompany,
      projectAdminRoles = []
    ) => {
      var sts = (
        // (getUserCompanyDetails === expectedCompany && proj_access_level === true || projectAdminRoles.some(item => userRoleManual?.includes?.(item)))
        projectAdminRoles.some(item => userRoleManual?.includes?.(item))
      );
      return sts;
    };


    return (
      <div className="bodywrap add-new-row-maindiv" >
        {loading && <FullscreenLoader />}
        <div className="header">
          <div className="projectwrap">
            <div className="addwbswrap">
              <input
                type="text"
                id="groupDesc"
                placeholder="Group Description"
                value={newGroup}
                onChange={(e) => setNewGroup(e.target.value)}
                required
              />
              <button id="addWbs_group"
                disabled={
                  !(
                    addGroupLoading === false && (btn_sts("NUS", ['Project Manager (PM)']))
                    // (
                    //   (getUserCompanyDetails === 'NUS' && userPermission === 'account_admin') ||
                    //   (getUserCompanyDetails === 'NUS' && userPermission === 'project_admin' && userRoleManual === '') ||
                    //   (getUserCompanyDetails === 'NUS' && userPermission === 'project_admin' && userRoleManual === 'Project Manager (PM)')
                    //   // (userRoleManual === 'Project Manager (PM)' && (userPermission === 'project_admin' || userPermission === 'account_admin'))
                    // )
                  )
                }
                onClick={handleAddGroup}
                style={{
                  padding: '5px 20px',
                  backgroundColor:
                    // (
                    //   (getUserCompanyDetails === 'NUS' && userPermission === 'account_admin') ||
                    //   (getUserCompanyDetails === 'NUS' && userPermission === 'project_admin' && userRoleManual === '') ||
                    //   (getUserCompanyDetails === 'NUS' && userPermission === 'project_admin' && userRoleManual === 'Project Manager (PM)')
                    //   // (userRoleManual === 'Project Manager (PM)' && (userPermission === 'project_admin' || userPermission === 'account_admin'))
                    // )
                    (btn_sts("NUS", ['Project Manager (PM)'])) ? '' : 'grey'
                }}
              >
                Add New Group
              </button>
            </div>
            <div className="addwbswrap">
              <select
                id="groupSelect"
                value={selectedGroup.length > 0 ? selectedGroup[0].P_grp_id : ""} // Check if selectedGroup is not empty before accessing P_grp_id
                onChange={handleSelectChange}
              >
                <option value="" disabled>
                  Select Group
                </option>
                {groupOptions.map((group, index) => (
                  <option key={index} value={group.P_grp_id}>
                    {group.P_grp_desc}  {/* Display the group description */}
                  </option>
                ))}
              </select>
              <input
                type="text"
                id="itemDesc"
                placeholder="Item Description"
                value={itemDescription}
                onChange={(e) => setItemDescription(e.target.value)}
              />
              <button id="addWbs_item"
                disabled={
                  !(
                    addItemLoading === false && (btn_sts("NUS", ['Project Manager (PM)']))
                    // (
                    //   (getUserCompanyDetails === 'NUS' && userPermission === 'account_admin') ||
                    //   (getUserCompanyDetails === 'NUS' && userPermission === 'project_admin' && userRoleManual === '') ||
                    //   (getUserCompanyDetails === 'NUS' && userPermission === 'project_admin' && userRoleManual === 'Project Manager (PM)')
                    //   // (userRoleManual === 'Project Manager (PM)' && (userPermission === 'project_admin' || userPermission === 'account_admin'))
                    // )
                  )
                }
                onClick={handleAddNewItem}
                style={{
                  padding: '5px 20px',
                  backgroundColor:
                    // (
                    //   (getUserCompanyDetails === 'NUS' && userPermission === 'account_admin') ||
                    //   (getUserCompanyDetails === 'NUS' && userPermission === 'project_admin' && userRoleManual === '') ||
                    //   (getUserCompanyDetails === 'NUS' && userPermission === 'project_admin' && userRoleManual === 'Project Manager (PM)')
                    //   // (userRoleManual === 'Project Manager (PM)' && (userPermission === 'project_admin' || userPermission === 'account_admin'))
                    // )
                    (btn_sts("NUS", ['Project Manager (PM)'])) ? '' : 'grey'
                }}
              >
                Add New Item
              </button>
            </div>
            <div className="action-buttons">
              {/* --- START MODIFICATION: 'Save' button only enabled if modified --- */}
              <button id="submit"
                disabled={
                  !(
                    finalSubmitLoading === false && (btn_sts("NUS", ['Project Manager (PM)'])) && isModified
                  )
                }
                onClick={finalSubmit}
                style={{
                  backgroundColor:
                    (btn_sts("NUS", ['Project Manager (PM)']) && isModified) ? '' : 'grey'
                }}
              >
                Save
              </button>
              {/* --- END MODIFICATION --- */}

              {/* --- START MODIFICATION: 'Submit to AC' button only enabled if modified --- */}
              <button id="submit_to_ac"
                disabled={
                  !(
                    finalSubmitLoading === false && (btn_sts("NUS", ['Project Manager (PM)'])) && isModified
                  )
                }
                onClick={
                  handleSubmitAC
                }
                style={{
                  backgroundColor:
                    (btn_sts("NUS", ['Project Manager (PM)']) && isModified) ? '#4CAF50' : 'grey', color: 'white'
                }}
              >
                Submit to AC
              </button>
              {/* --- END MODIFICATION --- */}
            </div>

           
          </div>
        </div>

        {/* <div className="tablewrap" style={{ overflowY: 'auto', maxHeight: '700px', border: '1px solid #ddd' }}> */}
        <div id="master-div" className={`${ wbsColumns.length < 4 ? "main-div2" : "main-div1"} tablewrap`} style={{ overflowY: 'auto', border: '1px solid #ddd'}}>
          <table id="wbsTable">
            <thead>
              <tr>
                <th style={{ width:  "410px" }} className="description-column">WBS No</th>
                {wbsColumns.map((wbsId, index) => (
                  <th key={index}>{wbsId}</th>
                ))}
                <th className="description-column">Total</th>
              </tr>
            </thead>
            <tbody>
              {rows.length === 0 ? (
                <tr>
                  <td colSpan={wbsColumns.length + 2} style={{ textAlign: 'center', height: '100px', verticalAlign: 'middle', padding: '20px' }}>{WBSTableLoading ? 'Loading...' : 'No records found'}</td>
                </tr>
              ) : (
                rows.map((row, rowIndex) => (
                  <tr key={rowIndex}>
                    <td style={{ width:  "410px" }} className={rowIndex > 1 ? "undescription-column-2" : "undescription-column"}>{row.description}</td>
                    {row.data.map((item, itemIndex) => (
                      <td key={item.id} className={rowIndex > 1 ? "undescription-column-2" : "undescription-column"}>
                        {(rowIndex == 2) ? formatCurrency(item.value) : item.value}
                        {/* {item.value} */}
                      </td>
                    ))}
                    {rowIndex !== 1 && <td rowSpan={rowIndex == 0 ? 2 : 0} className={rowIndex > 1 ? "undescription-column-2" : "undescription-column"}>{rowIndex < 2 ? "" : formatCurrency(row.total)}</td>}
                    {/* <td className="total-column">{rowIndex < 2 ? "" : formatCurrency(row.total)}</td> */}
                  </tr>
                ))
              )}
            </tbody>
          </table>
          <br />
          <div className="table-container">
            <table id="costTable"  className="costTable">
              {/* style={{ width: '100%' }} */}
              <thead>
                <tr>
                  <th colSpan="2" id="description-wbs">Description</th>
                  <th id="contract-wbs">Contract Sum</th>
                  {wbsColumns.map((wbsId, index) => (
                    <th key={index}>{wbsId}</th>
                  ))}
                  <th>Total</th>
                </tr>
              </thead>
              <tbody>

                {(addedItems.length === 0 || WBSTableLoading || WBSEditTableLoading) ? (
                  <tr>
                    <td colSpan={wbsColumns.length + 4} style={{ textAlign: 'center', height: '100px', verticalAlign: 'middle', padding: '20px' }}>{(WBSEditTableLoading || WBSTableLoading) ? 'Loading...' : 'No records found'}</td>
                  </tr>
                ) : (

                  addedItems.map((group, groupIndex) => {
                    // Group total value
                    // const groupTotalValue = group.descriptions.reduce((groupAcc, descriptionObj) => {
                    //   const rowTotal = Object.values(descriptionObj.wbsValues || {}).reduce((rowAcc, value) => {
                    //     return rowAcc + (parseFloat(value) || 0);
                    //   }, 0);
                    //   return groupAcc + rowTotal;
                    // }, 0);
                    const groupTotalValue = group.descriptions.reduce((groupAcc, descriptionObj) => {
                      const rowTotal = Object.values(descriptionObj.wbsValues || {}).reduce((rowAcc, value) => {
                        // Remove commas if value is a string, and parse it as a float
                        const cleanedValue = value ? String(value).replace(/,/g, '') : ''; // Remove commas and ensure value is a string
                        return rowAcc + (parseFloat(cleanedValue) || 0); // Parse cleaned value and treat NaN as 0
                      }, 0);
                      return groupAcc + rowTotal; // Sum the row totals for all descriptions in the group
                    }, 0);


                    return (
                      <React.Fragment key={`group-${groupIndex}`}>
                        <tr style={{ backgroundColor: '#e6f0ff' }}>
                          <td colSpan="2" style={{ fontWeight: 'bold' }}>{group.group}</td>
                          <td></td>
                          {wbsColumns.map((wbsId, columnIndex) => {
                            // const columnTotal = group.descriptions.reduce(
                            //   (acc, descriptionObj) => acc + (parseFloat(descriptionObj.wbsValues?.[wbsId]) || 0),
                            //   0
                            // );
                            const columnTotal = group.descriptions.reduce(
                              (acc, descriptionObj) => {
                                const value = descriptionObj.wbsValues?.[wbsId];
                                const cleanedValue = value ? String(value).replace(/,/g, '') : '';
                                return acc + (parseFloat(cleanedValue) || 0);
                              },
                              0
                            );

                            return <td className="group-col-tot" title={formatCurrency(columnTotal.toFixed(2))} key={`group-total-${columnIndex}`}>{formatCurrency(columnTotal.toFixed(2))}</td>;
                          })}
                          <td>{formatCurrency(groupTotalValue.toFixed(2))}</td>
                        </tr>
                        {group.descriptions.map((descriptionObj, descIndex) => {
                          // const rowTotalValue = Object.values(descriptionObj.wbsValues || {}).reduce(
                          //   (acc, value) => acc + (parseFloat(value) || 0),
                          //   0
                          // );
                          const rowTotalValue = Object.values(descriptionObj.wbsValues || {}).reduce(
                            (acc, value) => {
                              // Ensure the value is a string before replacing commas
                              const cleanedValue = String(value).replace(/,/g, '');  // Convert value to string and remove commas
                              return acc + (parseFloat(cleanedValue) || 0); // Handle NaN by defaulting to 0
                            },
                            0
                          );


                          return (
                            <tr className="data-row" key={descIndex} style={{ backgroundColor: '#fff' }}>
                              <td className="sno-uni">{descIndex + 1}</td>
                              <td>{descriptionObj.description}</td>
                              <td>from LOA</td>
                              {wbsColumns.map((wbsId, columnIndex) => (
                                <td key={`cost-${groupIndex}-${columnIndex}`}>

                                  <div className="input-wrapper">
                                    <span className="input-prefix">$</span>
                                    <input
                                      className="custom-input"
                                      type="text"
                                      value={                                       
                                        // focusedInput === `${groupIndex}-${descIndex}-${columnIndex}`
                                        //   ? descriptionObj.wbsValues?.[wbsId] ?? ''
                                        //   : formatAsCurrency(descriptionObj.wbsValues?.[wbsId])

                                        // focusedInput === `${groupIndex}-${descIndex}-${columnIndex}` ?
                                        // (descriptionObj.wbsValues?.[wbsId] === '0' ? '' :
                                        //   descriptionObj.wbsValues?.[wbsId] ?? '')
                                        //   : formatAsCurrency(descriptionObj.wbsValues?.[wbsId])

                                        focusedInput === `${groupIndex}-${descIndex}-${columnIndex}`
                                          ? (isEmptyValue(descriptionObj.wbsValues?.[wbsId])
                                            ? ''
                                            : descriptionObj.wbsValues?.[wbsId])
                                          : (isEmptyValue(descriptionObj.wbsValues?.[wbsId])
                                            ? ''
                                            : formatAsCurrency(descriptionObj.wbsValues?.[wbsId]))



                                        // focusedInput === `${groupIndex}-${descIndex}-${columnIndex}`
                                        //   ? // --- WHILE TYPING/FOCUSED ---
                                        //   // If it's null or undefined, show ''. If it's 0 or any other number, show it exactly as is.
                                        //   (descriptionObj.wbsValues?.[wbsId] ?? '')
                                        //   : // --- WHILE BLURRED/LOADING ---
                                        //   // If the value is genuinely empty/null, leave the input blank.
                                        //   isEmptyValue(descriptionObj.wbsValues?.[wbsId])
                                        //     ? ''
                                        //     : // If it's exactly 0 or '0', display it as '0' or '0.00' based on your preference.
                                        //     Number(descriptionObj.wbsValues?.[wbsId]) === 0
                                        //       ? '0'
                                        //       : formatAsCurrency(descriptionObj.wbsValues?.[wbsId])



                                        
                                        // focusedInput === `${groupIndex}-${descIndex}-${columnIndex}`
                                        //   ? (
                                        //     isEmptyValue(descriptionObj.wbsValues?.[wbsId])
                                        //       ? ''
                                        //       : descriptionObj.wbsValues?.[wbsId]
                                        //   )
                                        //   : (
                                        //     isEmptyValue(descriptionObj.wbsValues?.[wbsId])
                                        //       ? ''
                                        //       : (
                                        //         Number(descriptionObj.wbsValues?.[wbsId]) === 0
                                        //           ? '0'
                                        //           : formatAsCurrency(descriptionObj.wbsValues?.[wbsId])
                                        //       )
                                        //   )

                                        // focusedInput === `${groupIndex}-${descIndex}-${columnIndex}`
                                        //   ? (descriptionObj.wbsValues?.[wbsId] ?? '')
                                        //   : (
                                        //     descriptionObj.wbsValues?.[wbsId] != null &&
                                        //       descriptionObj.wbsValues?.[wbsId] !== ''
                                        //       ? Number(descriptionObj.wbsValues?.[wbsId]) === 0
                                        //         ? '0'
                                        //         : formatAsCurrency(descriptionObj.wbsValues?.[wbsId])
                                        //       : ''
                                        //   )
                                        

                                        // focusedInput === `${groupIndex}-${descIndex}-${columnIndex}`
                                        //   ? (descriptionObj.wbsValues?.[wbsId] ?? '')
                                        //   : formatAsCurrency(descriptionObj.wbsValues?.[wbsId])

                                      }
                                      onFocus={() => {
                                        setFocusedInput(`${groupIndex}-${descIndex}-${columnIndex}`);
                                      }}
                                      onBlur={(e) => {
                                        // const cleaned = e.target.value.replace(/[^0-9.]/g, '');

                                        // const cleaned = e.target.value.replace(/[^0-9.-]/g, '');
                                        // const parsed = parseFloat(cleaned);

                                        // let rawValue = '';
                                        // if (!isNaN(parsed) && parsed !== 0) {
                                        //   rawValue = parsed.toString(); // Store unformatted number
                                        // }

                                        //const cleaned = e.target.value.trim();
                                        const cleaned = e.target.value.replace(/[^0-9.-]/g, '');
                                        const parsed = parseFloat(cleaned); // <-- ADD THIS
                                        let rawValue = '0';

                                        if (cleaned !== '' && cleaned !== '-' && cleaned !== '.' && cleaned !== '-.') {
                                          rawValue = parsed.toString();
                                        }

                                        handleCostInputChange(groupIndex, descIndex, columnIndex, rawValue);
                                        setFocusedInput(null); // trigger formatted display
                                      }}
                                      onChange={(e) => {
                                        // let value = e.target.value;

                                        // // <-- MODIFIED
                                        // if (!isValidCurrencyLength(value, 14)) {
                                        //   return;
                                        // }

                                        // let newValue = e.target.value.replace(/[^0-9.]/g, '');

                                        // let newValue = e.target.value.replace(/[^0-9.-]/g, '');

                                        // if (newValue === '' || isValidNumber(newValue)) {
                                        //   handleCostInputChange(groupIndex, descIndex, columnIndex, newValue);
                                        // }

                                        let newValue = e.target.value;

                                        if (!isValidCurrencyLength(newValue, 14)) {
                                          return;
                                        }

                                        // Allow only digits, decimal and minus
                                        newValue = newValue.replace(/[^0-9.-]/g, '');

                                        if (isValidNumber(newValue)) {
                                          handleCostInputChange(groupIndex, descIndex, columnIndex, newValue);
                                        }

                                      }}
                                    />

                                    


                                  </div>
                                </td>
                              ))}
                              <td>{formatCurrency(rowTotalValue.toFixed(2))}</td>
                            </tr>
                          );
                        })}
                      </React.Fragment>
                    );
                  })
                )}
              </tbody>
              {!WBSEditTableLoading && (
                <tfoot>
                  {/* GST Calculation Row */}
                  <tr style={{ backgroundColor: '#e6f0ff' }}>
                    <td colSpan="2">GST (on all items above excluding GST Adjustments, if any)</td>
                    <td></td>
                    {wbsColumns.map((_, columnIndex) => {
                      const allGroupTotalValue = addedItems.reduce((groupAcc, group) => {
                        return groupAcc + group.descriptions.reduce((descAcc, descriptionObj) => {
                          const value = descriptionObj.wbsValues?.[wbsColumns[columnIndex]];
                          const cleanedValue = value ? String(value).replace(/,/g, '') : '0';
                          return descAcc + (parseFloat(cleanedValue) || 0);
                        }, 0);
                      }, 0);
                      const ninePercentValue = (allGroupTotalValue * 0.09).toFixed(2);
                      return <td key={`all-group-total-${columnIndex}`}>{formatCurrency(ninePercentValue)}</td>;
                    })}
                    <td>
                      {formatCurrency(wbsColumns.reduce((total, _, columnIndex) => {
                        const allGroupTotalValue = addedItems.reduce((groupAcc, group) => {
                          return groupAcc + group.descriptions.reduce((descAcc, descriptionObj) => {
                            const value = descriptionObj.wbsValues?.[wbsColumns[columnIndex]];
                            const cleanedValue = value ? String(value).replace(/,/g, '') : '0';
                            return descAcc + (parseFloat(cleanedValue) || 0);
                          }, 0);
                        }, 0);
                        return total + allGroupTotalValue * 0.09;
                      }, 0).toFixed(2))}
                    </td>
                  </tr>

                  {/* Total Project Cost Row */}
                  <tr style={{ backgroundColor: '#e6f0ff' }}>
                    <td colSpan="2">Total Project Cost</td>
                    <td></td>
                    {wbsColumns.map((_, columnIndex) => {
                      const allGroupTotalValue = addedItems.reduce((groupAcc, group) => {
                        return groupAcc + group.descriptions.reduce((descAcc, descriptionObj) => {
                           const value = descriptionObj.wbsValues?.[wbsColumns[columnIndex]];
                            const cleanedValue = value ? String(value).replace(/,/g, '') : '0';
                          return descAcc + (parseFloat(cleanedValue) || 0);
                        }, 0);
                      }, 0);
                      const ninePercentValue = allGroupTotalValue * 0.09;
                      const totalProjectCost = allGroupTotalValue + ninePercentValue;
                      return <td key={`total-project-cost-${columnIndex}`}>{formatCurrency(totalProjectCost.toFixed(2))}</td>;
                    })}
                    <td>
                      {formatCurrency(wbsColumns.reduce((total, _, columnIndex) => {
                        const allGroupTotalValue = addedItems.reduce((groupAcc, group) => {
                          return groupAcc + group.descriptions.reduce((descAcc, descriptionObj) => {
                            const value = descriptionObj.wbsValues?.[wbsColumns[columnIndex]];
                            const cleanedValue = value ? String(value).replace(/,/g, '') : '0';
                            return descAcc + (parseFloat(cleanedValue) || 0);
                          }, 0);
                        }, 0);
                        const ninePercentValue = allGroupTotalValue * 0.09;
                        return total + allGroupTotalValue + ninePercentValue;
                      }, 0).toFixed(2))}
                    </td>
                  </tr>
                  {/* Type 1 Savings Row */}
                  <tr style={{ backgroundColor: '#e6f0ff' }}>
                    <td colSpan="2">Type 1 Savings (to declare for savings of $50k and above)</td>
                    <td></td>
                    {wbsColumns.map((_, columnIndex) => {
                      // Step 1: Calculate the Approved Budget for the current column (from first table)
                      const approvedBudget = rows.reduce((acc, row) => {
                        const itemValue = row.data[columnIndex]?.value; // Get value for the current column
                        // Add the value if it's valid (ensure it's a valid number)
                        if (!isNaN(itemValue)) {
                          return parseFloat(itemValue);
                        }
                        return acc;
                      }, 0);
                      const totalProjectCost = addedItems.reduce((groupAcc, group) => {
                        return groupAcc + group.descriptions.reduce((descAcc, descriptionObj) => {
                          // Retrieve the value for the current column from wbsValues
                          const value = descriptionObj.wbsValues?.[wbsColumns[columnIndex]];
                          const cleanedValue = value ? String(value).replace(/,/g, '') : '0';
                          return descAcc + (parseFloat(cleanedValue) || 0);
                        }, 0);
                      }, 0);
                      const gst = totalProjectCost * 0.09;
                      const totalProjectCostWithGST = totalProjectCost + gst;
                      const savings = approvedBudget - totalProjectCostWithGST;
                      return (
                        <td key={`type-1-savings-${columnIndex}`}>
                          {isNaN(savings) || savings === 0 ? '$0.00' : formatCurrency(savings.toFixed(2))}
                        </td>
                      );
                    })}
                    {/* Grand Total Savings (for all columns) */}
                    <td>
                      {formatCurrency(wbsColumns.reduce((total, _, columnIndex) => {
                        const approvedBudget = rows.reduce((acc, row) => {
                          const itemValue = row.data[columnIndex]?.value;
                          if (!isNaN(itemValue)) {
                            return parseFloat(itemValue);
                          }
                          return acc;
                        }, 0);
                        const totalProjectCost = addedItems.reduce((groupAcc, group) => {
                          return groupAcc + group.descriptions.reduce((descAcc, descriptionObj) => {
                            const value = descriptionObj.wbsValues?.[wbsColumns[columnIndex]];
                            const cleanedValue = value ? String(value).replace(/,/g, '') : '0';
                            return descAcc + (parseFloat(cleanedValue) || 0);
                          }, 0);
                        }, 0);
                        const gst = totalProjectCost * 0.09;
                        const totalProjectCostWithGST = totalProjectCost + gst;

                        const savings = approvedBudget - totalProjectCostWithGST;
                        return total + (isNaN(savings) ? 0 : savings);
                      }, 0).toFixed(2))}
                    </td>
                  </tr>

                  {/* Interim Type 3 Row */}
                  <tr style={{ backgroundColor: '#e6f0ff' }}>
                    <td colSpan="2">Interim Type 3</td>
                    <td></td>
                    {wbsColumns.map((_, columnIndex) => (
                      <td key={`interim-type-3-${columnIndex}`}>0</td>
                    ))}
                    <td>0</td>
                  </tr>
                </tfoot>
              )}
            </table>
          </div>
        </div>
      </div>
    );

}
export default Wbs2iframerow;